import React from "react";
import Layout from "../components/layout";
import BlogRoll from "../components/BlogRoll"
import Head from "../components/head";



export default () => (
    <Layout>
        <Head title="tous les defis" />
        <h1>Tous les Challenges</h1>
          <section>
            <div className="content">
              <BlogRoll categorie={"ctf"} />
            </div>
          </section>
    </Layout>
)